import { Card, CardContent } from '@mui/material';
import { Title } from 'react-admin';
import { MetricChart } from '../components/MetricChart';

export const Dashboard = () => (
	<Card>
		<Title title="Dashboard" />
		<CardContent>
			<MetricChart />
		</CardContent>
	</Card>
);

export default Dashboard;